import { ContractDetail, ContractExpensesReport } from '@/custom-types';
import { createContext } from 'react';

export type ContractDetailsContextProps = {
  contract: ContractDetail | undefined,
  expensesReport: ContractExpensesReport | undefined,
  setContract: (contract: ContractDetail | undefined) => void,
  setExpensesReport: (expensesReport: ContractExpensesReport | undefined) => void
}

export const ContractDetailsContext = createContext<ContractDetailsContextProps | null>(null)
